import axios from "axios";
import Swal from "sweetalert2";
export const axiosHelper = async ({
  url = "",
  method = "get",
  data = {},
  requested = 0,
  showAlert = true,
  file,
  pendientes,
  finalizado,
  eventoseguridad,
  busqueda,
}) => {
  let url1 = "";

  switch (process.env.REACT_APP_MODE) {
    case "LOCAL":
      url1 = process.env.REACT_APP_API_URL_LOCAL;
      break;
    case "PRODUCTION":
      url1 =
        window.location.protocol +
        "//" +
        window.location.hostname +
        process.env.REACT_APP_API_URL_PROD;
      break;
    default:
      url1 = process.env.REACT_APP_API_URL_TEST;
      break;
  }
  var config = {
    method: method,
    url: url1 + url,
    headers: {
      "Content-Type": file? "multipart/form-data": "application/json",
      "x-token": localStorage.getItem("xt"),
      "pendientes": pendientes?pendientes:false,
      "finalizado": finalizado?finalizado:false,
      "evento-seguridad": eventoseguridad?eventoseguridad:false,
      "x-tipo-busqueda": busqueda?busqueda:false,
    },
    data: file? data: JSON.stringify(data),
  };

  let resp = await axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      let message =
        error.message === "Network Error"
          ? "Tenemos problemas con nuestro servidor de datos, estamos trabajando para restablecer la conexión, intenta más tarde. O revisa tu conexión a internet."
          : error.response.data.msg
          ? error.response.data.msg
          : "Ha ocurrido un error inesperado, intenta más tarde.";
      if (error.message !== "Network Error")
        if (error.response.status === 503 || error.request.status === 503) {
          if (requested < 3)
            return axiosHelper({ url, method, data, requested: requested + 1 });
          message =
            "Tenemos un problema en nuestros servidores principales, estamos trabajando para corregir los problemas. ";
        }
      if (showAlert && error.response && error.response.status === 500) Swal.fire({ title: "!Lo siento!", text: message, icon: "error" });
      return { ok: false, msg: message };

      // if (showAlert) Swal.fire({ title: "Ups!", text: message, icon: "error" });
      // return { ok: false, msg: message };
    });
  return resp;
};
